import { gql } from '@apollo/client';

export const getBaseCurrencyQuery = gql`
    {
        getBaseCurrency{
          id
          symbol
        }
    }`;

export const currencyManagementMutation = gql`
    mutation currencyManagement ($id: Int, $isEnable: Boolean, $symbol: String){
                    currencyManagement(id: $id, isEnable: $isEnable, symbol: $symbol){
                        status
                        errorMessage
                    }
    }
    `;

export const setBaseCurrencyMutation = gql`
    mutation setBaseCurrency($id: Int){
        baseCurrency(id: $id){
            status
        }
    }
    `;

export const managePaymentCurrency = gql`
    mutation managePaymentCurrency(
      $currencyId: Int!, 
      $type: String!
    ){
        managePaymentCurrency(
          currencyId: $currencyId, 
          type: $type
        ) {
            status
        }
    }
    `;

export const getCurrencies = gql`
    query getCurrencies{
    getCurrencies{
      id
      isBaseCurrency
      symbol
      isEnable
      isPayment
  }
}
`;

export const currency = gql`
    {
      Currency{
          base
          rates
      }
    }
    `;

export const getAllCurrenciesQuery = gql`
  query getAllCurrencies($currentPage:Int,$searchList:String){
  getAllCurrencies(currentPage:$currentPage,searchList:$searchList){
    results{
      id
      isBaseCurrency
      symbol
      isEnable
      isPayment
    }
    count
  }
}
`;
export const updatePayoutCurrencyMutation = gql`mutation updatePayoutCurrency ($id: Int, $symbol: String , $isPayoutCurrency: Boolean){
          updatePayoutCurrency(id: $id, symbol: $symbol, isPayoutCurrency: $isPayoutCurrency){
                status
                errorMessage
            }
          }`
